<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  <!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">

        <!-- Actions header (sticky within scrollable content) -->

        <!-- Table body -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">
          <div class=" d-flex justify-content-between align-items-center sticky-top mb-2">
            <button
              class="btn btn-primary btn-sm rounded-3 shadow-sm lh-sm  float-end"
              @click="openCreateModal"
            >
              <span class="small text-xxs d-flex align-items-center gap-1">
                <i class="bx bx-plus fs-6"></i>
                Create Survey
              </span>
            </button>
          </div>
          <!-- table -->
           <div v-show="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Survey List...</p>
            </div>
            <div v-show="!isLoading">
              <div v-if="surveys && surveys.length === 0" 
                class="d-flex flex-column align-items-center justify-content-center text-center py-5 w-100">
                
                <i class="bi bi-clipboard2-data display-1 text-light-emphasis mb-3" aria-hidden="true"></i>
                
                <h5 class="text-muted fw-normal">No surveys found</h5>
                <p class="text-muted small">When you create a new surveys, they will appear here.</p>
            </div>
          <div v-else class="table-responsive">
            <table id="survey-table" class="table align-middle table-striped table-borderless mb-0">
              <thead class="text-uppercase btn-primary text-white ">
                <tr>
                  <th class="text-xxs fw-light">No.</th>
                  <th class="text-xxs fw-light text-center">Survey Name</th>
                  <th class="text-xxs fw-light text-center">description</th>
                  <th class="text-xxs fw-light text-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                <!-- Apply text-xxs at the row level for all cells -->
                <tr v-for="(survey, index) in surveys" :key="survey.id" class="border-bottom text-xxs">
                  <!-- Number -->
                  <td class="text-center">
                    <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                      {{ index + 1 }}
                    </span>
                  </td>

                  <!-- Survey Name -->
                  <td class="text-center">
                    <div class="text-xxs">{{ survey.name }}</div>
                  </td>

                  <!-- Type -->
                  <td class="text-center">
                    <span class="chip chip-info text-xxs">
                      {{ survey.description || 'N/A' }}
                    </span>
                  </td>
                  <!-- Actions -->
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-1">
                      <router-link
                        :to="'create_segment/' + survey.id + '/'+ survey.id+'/'"
                        class="btn btn-light btn-sm rounded-3 text-primary border"
                      >
                        <span class="text-xxs">View</span>
                      </router-link>

                      <button
                        class="btn btn-light btn-sm rounded-3 text-success border"
                        @click="openEditModal(survey)"
                      >
                        <span class="text-xxs">Edit</span>
                      </button>

                      <button
                        class="btn btn-light btn-sm rounded-3 text-danger border"
                        @click="deleteSurvey(survey.id)"
                      >
                        <span class="text-xxs">Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
          </div>
        </div>

      </div>

    </div> <!-- /row -->
  </div> <!-- /container-fluid -->

</div> <!-- /app shell -->


<!-- Create / Edit Survey Modal -->
 <teleport to="body">
<div class="modal fade" id="create_survey" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="exampleModalLabel">
            {{ isEditMode ? 'Edit Survey' : 'Create a Survey' }}
          </p>

          <!-- Close button on the end with white "X" -->
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>

      </div>
      <div class="card-body p-3 modal-body modal-body-scroll">
      <form @submit.prevent="submitSurvey()">
                    <button v-if="!survey_id" class="btn btn-sm text-muted position-absolute top-0 end-0 m-2"
                        @click="cancelEdit" title="Close">
                        <i class="bi bi-x-lg fs-5 fw-bold text-dark"></i>
                    </button>
                    <!-- Survey Title -->
                    <div class="mb-3">
                        <label for="survey_name" class="form-label text-xxs fw-500">Survey Name<span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control rounded text-xxs" id="survey_name"
                            placeholder="Enter survey name" v-model="survey_name">
                        <p v-if="errors.survey_name" class="text-danger text-xxs mt-1">{{ errors.survey_name }}</p>
                    </div>

                    <!-- Survey Description -->
                    <div class="mb-3">
                        <label for="survey_description" class="form-label text-xxs fw-500">Survey Description</label>
                        <QuillEditor theme="snow" v-model="survey_description" ref="quillSurveyEditorRef"
                            class="quill-editor" placeholder="Enter your description here..." toolbar="half" />
                    </div>
                    <div class="mb-3 p-2">
                        <button type="button" class="btn btn-primary btn-sm float-end text-xxs rounded shadow-sm"
                            @click="showQuestionForm = !showQuestionForm">
                            <i class="bi bi-plus-lg me-1"></i>
                            {{ showQuestionForm ? 'Hide Question Form' : 'Add Question' }}
                        </button>
                        <div v-if="showQuestionForm">

                            <div class="row mt-2 w-100 ">
                                <!-- Question Input -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Question <span class="text-danger">*</span></label>
                                    <div class="d-flex">
                                        <input type="text" class="form-control text-xxs rounded p-2 bg-white"
                                            v-model="newQuestion.text" placeholder="Enter question text"
                                            list="questionSuggestions" @input="onQuestionInput"
                                            @change="onQuestionSelect" />
                                    </div>
                                    <datalist id="questionSuggestions">
                                        <option v-for="question in filteredQuestions" :key="question.id"
                                            :value="question.question"></option>
                                    </datalist>
                                </div>

                                <!-- Question Number Input -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Question Number <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control text-xxs rounded p-2 bg-white"
                                        placeholder="Eg. 1" v-model="newQuestion.question_number" />
                                </div>

                                <!-- Question Type Select -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Type <span class="text-danger">*</span></label>
                                    <select v-model="newQuestion.type" class="form-select text-xxs p-2 rounded">
                                        <option value="" disabled>Select</option>
                                        <option
                                            v-for="type in question_types.filter(t => t.question_type !== 'file' && t.question_type !== 'textarea')"
                                            :key="type.id" :value="type.id">
                                            {{ type.question_type }}
                                        </option>
                                    </select>

                                    <!-- Options Input for Multiple Choice, Checkbox, or Selection -->
                                    <div v-if="newQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === newQuestion.type)?.question_type)"
                                        v-for="(option, index) in newQuestion.options" :key="option.id || index"
                                        class="d-flex align-items-center mt-2 mb-2">
                                        <input type="text" class="form-control text-xxs rounded p-2 me-2"
                                            v-model="option.text" placeholder="Enter option text" />
                                        <button class="btn btn-danger btn-sm text-xxs" type="button"
                                            @click="removeOption(index)">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </div>

                                    <div
                                        v-if="newQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === newQuestion.type)?.question_type)">
                                        <button
                                            class="btn btn-sm btn-warning text-white mt-3 text-xxs rounded shadow-sm fw-500"
                                            type="button" @click="addOption">
                                            Add Option
                                        </button>
                                    </div>
                                </div>

                                <!-- Is Mandatory Select -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Is the question mandatory?</label>
                                    <select v-model="newQuestion.is_mandatory" class="form-select text-xxs p-2 rounded">
                                        <option :value="true">Yes</option>
                                        <option :value="false">No</option>
                                    </select>
                                </div>

                                <!-- Add Question Button -->
                                <div class="col-12 mt-3">
                                    <button type="button" class="btn btn-sm btn-success text-xxs rounded float-end"
                                        @click="addQuestionToSurvey"
                                        :disabled="!newQuestion.text || !newQuestion.type || !newQuestion.question_number">
                                        Add Question to Survey
                                    </button>
                                </div>
                            </div>
                            <div class="mt-3" v-if="createdQuestions.length > 0">
                                <h6 class="text-xxs fw-semibold">Created Questions</h6>
                                <!-- <ul>
                                <li > -->
                                <div v-for="(question, index) in createdQuestions" :key="index"
                                    class="d-flex justify-content-between align-items-center border rounded p-2 text-xxs mb-2">
                                    <div>
                                        <span class="text-xxs">{{ index + 1 }}. {{ question.text }}</span>
                                        <span class="badge bg-secondary ms-2 text-xxs rounded">
                                            {{ question.type ? (question_types.find(t => t.id ===
                                            question.type)?.question_type || 'Unknown') : 'Unknown' }}
                                        </span>
                                        <span v-if="question.is_mandatory"
                                            class="badge bg-danger ms-1 text-xxs">Required</span>
                                    </div>
                                    <button type="button" class="btn btn-sm text-danger"
                                        @click="remove_created_question(index)" title="Remove">
                                        <i class="bi bi-trash text-danger"></i>
                                    </button>
                                </div>
                                <!-- </li>
                            </ul> -->
                            </div>
                            <div class="d-flex justify-content-end" v-if="createdQuestions.length > 0">
                                <button type="submit" class="btn btn-sm btn-primary text-xxs rounded">
                                    {{ survey_id ? 'Update' : 'Create' }} Survey
                                </button>
                                <button v-if="survey_id" type="button"
                                    class="btn btn-sm btn-danger text-xxs rounded ms-2" @click="cancelEdit">
                                    Cancel
                                </button>
                            </div>
                        </div>

                    </div>

                    <!-- Submit -->

                </form>
        </div>
    </div>
  </div>
</div>
</teleport>
